// extracted by mini-css-extract-plugin
export default {"entityForm":"EntityForm_entityForm__ITCHL"};